export function state () {
  return {
    packageVersion: process.env.PACKAGE_VERSION || '0',
    headerPageTitle: '',
    // right navigation panel
    rightActiveComponent: {},
    rightNavHistory: [],
    showRightLoader: false,
    // left navigation panel
    leftActiveComponent: {},
    leftNavHistory: [],
    showLeftLoader: false,
    // top navigation panel
    topActiveComponent: {},
    topNavHistory: [],
    showTopLoader: false,
    // bottom navigation panel
    bottomActiveComponent: {},
    bottomNavHistory: [],
    showBottomLoader: false,
    // submenu navigation panel
    subMenuActiveComponent: {},
    subMenuHistory: [],
    showSubMenuLoader: false,
    bodyClass: null,
    isHero: false,
    // used to check if change states are not coming from change route
    // if $router use a replace all components active restart
    // using this parameter to avoid restarting state associated ex ui.middleware quickBuy/setToggle
    routerRefresh: false,
    headerHeight: 0,
    genericModalComponent: {
      title: '',
      component: false,
      modalProps: {}
    }
  }
}
